export function transformFilter(formData = {}) {
  const data = Object.assign({}, formData)
  const dates = data.dates

  if (dates) {
    data.from = dates.startDate ?? undefined
    data.to = dates.endDate ?? undefined
  }

  delete data.dates

  if (data.sku) {
    data.sku = String(data.sku).trim()
  }

  if (data.userId) {
    data.userId = String(data.userId).trim()
  }

  if (data.status === '') {
    delete data.status
  }

  if (data.action === '') {
    delete data.action
  }

  return data
}
